exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form {\r\n    padding: 15px;\r\n    border: 1px solid #ddd;\r\n}\r\n\r\ntextarea {\r\n    height: 250px;\r\n}\r\n\r\n.notes {\r\n    padding: 15px;\r\n}\r\n\r\n.area_message {\r\n    margin-bottom: 5px;\r\n}\r\n.error {\r\n    margin-bottom: 0px;\r\n}\r\nlabel.error {\r\n    color: #ff392d;\r\n}\r\n.failure {\r\n    color: #a94442;\r\n    background-color: #f2dede;\r\n    border-color: #ebccd1;\r\n    display: none;\r\n    width: 280px;\r\n    height: 34px;\r\n    padding:5px;\r\n    border-radius: 5px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/mail-template/mail-template.component.css
// module id = ../../../../../src/app/_components/mail-template/mail-template.component.css
// module chunks = main